import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import {
  Typography,
  CircularProgress,
  Card,
  ButtonBase,
  Divider,
  InputAdornment,
  Menu,
  MenuItem,
  TextField,    
} from '@material-ui/core'
import { BiCaretDown } from 'react-icons/bi'
import Cookies from 'js-cookie'
import DonutChart from '../charts/DonutChart'
import AskReport from '../AskReport'
import moment from 'moment'
import noImage from '../../assets/noImage.png'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/"
// const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm"

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#fff',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#fff',
      borderColor: '#fff'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const StyledTextFieldLT = styled(TextField)({
  '& label': {
    color: '#3d3d3d',
  },
  '& label.Mui-focused': {
    color: '#18bdfe',
  },
  '& .MuiOutlinedInput-root': {
    color: '#3d3d3d',
    borderRadius: "8px",
    '&:hover fieldset': {
      borderColor: '#18bdfe',
    },
    '& fieldset': {
      color: '#3d3d3d',
      borderColor: '#3d3d3d'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#18bdfe',
      color: '#3d3d3d',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#3d3d3d',
    backgroundColor: 'transparent',
    borderRadius: 4,
  }
})

const EventMarketing = props => {
  const {darkMode} = props
  const token = Cookies.get("token")
  const [ eventMarketingData, setEventMarketingData ] = useState(null)
  const [option, setOption] = useState("Sales")
  const [anchor, setAnchor] = useState(null)

  const getData = () => {
    const request = fetch(`${base_url}/tentpoleROI`, {
      headers: {"token": token}
    })

    request.then(response => response.json())
    .then(data => {
      if(data) setEventMarketingData(data.map(({Data_Extended}) => Data_Extended[0]))
      else setEventMarketingData([])
    })
  }

  useEffect(() => getData(), [])

  const openMenu = (e) => {
    const { currentTarget } = e
    setAnchor(currentTarget)
  }

  const closeMenu = () => {
    setAnchor(null)
  }
  
  const handleOptionSelect = (value) => {
    setOption(value)
    setAnchor(null)
  }

  if(!eventMarketingData) return <CircularProgress className="home-page-loader" />
  if(eventMarketingData && eventMarketingData.length < 1) return <AskReport home={true} />

  const totalData = eventMarketingData.reduce((a,b) => {
    for(const prop in b) {
      if(a.hasOwnProperty(prop) && prop !== "MaxWrittenDate") a[prop] += b[prop]
      else a[prop] = b[prop]
    }
    return a
  }, {})

  totalData["Res_Rate"] = totalData["Responses"] / totalData["Mailed"]
  totalData["HO_Res_Rate"] = totalData["HO_Resp"] / totalData["HO_Count"]

  const getDonutSeries = () => {
    let data = []
    let optionsHash = {
      "Mailed": ["Mailed", "HO_Count"],
      "Sales": ["Sales", "HO_Sales"],
      "Responses": ["Responses", "HO_Resp"]
    }

    for(let i = 0; i < optionsHash[option].length; i++) {
      data.push(Math.round(totalData[`${optionsHash[option][i]}`]))
    }

    return data
  }

  return (
    <div className="event-root">
      <Typography style={{fontSize: '12px', color: `${darkMode ? "#fff" : "#3d3d3d"}`}} align="center">
        On completed promotions, a total spend of <span style={{color: "#ed6868"}}>${Math.round(totalData.Cost).toLocaleString("en")}</span> has yielded <span style={{color: 'rgba(113, 177, 40)', fontWeight:'bold'}}>${Math.round(totalData.Sales).toLocaleString("en")}</span> in sales to responders (at a {(totalData.Res_Rate * 100).toFixed(2)}% response rate)
      </Typography>
      <div className="boom-home">
        <div className={`boom-stats-home ${darkMode ? "boom-home-dk" : "boom-home-lt"}`}>
          <div>
            <h5 style={{color: '#00c2bb'}}>AVG TICKET</h5>
            <span style={{fontSize: "15px", fontWeight: "bold"}}>${Math.round(totalData.Sales / totalData.Responses).toLocaleString('en')}</span>
          </div>
          <Divider className="divider"/>
          <div>
            <h5 style={{color: '#61b304'}}>INC SALES</h5> 
            <span style={{fontSize: "15px", fontWeight: "bold"}}>${Math.round(totalData.ADJ_Sales).toLocaleString('en')}</span>
          </div>
          <Divider className="divider"/>
          <div >
            <h5 style={{color: '#faa2f4'}}>INC RESPONSES</h5>
            <span style={{fontSize: "15px", fontWeight: "bold"}}>{Math.round(totalData.ADJ_Resp).toLocaleString('en')}</span>
          </div>
        </div>
        <div className="chart">
          {darkMode ? 
            <StyledTextField
              variant="outlined"
              size="small"
              className="select"
              value={option}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiCaretDown />
                  </InputAdornment>
                )
              }}
              onClick={openMenu}
            />
          :
            <StyledTextFieldLT
              variant="outlined"
              size="small"
              className="select"
              value={option}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <BiCaretDown />
                  </InputAdornment>
                )
              }}
              onClick={openMenu}
            />
          }

          <Menu
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClose={closeMenu}
          >
            <MenuItem onClick={() => handleOptionSelect("Sales")} value={"Sales"}><Typography variant="caption">Sales</Typography></MenuItem>
            <MenuItem onClick={() => handleOptionSelect("Mailed")} value={"Mailed"}><Typography variant="caption">Mailed</Typography></MenuItem>
            <MenuItem onClick={() => handleOptionSelect("Responses")} value={"Responses"}><Typography variant="caption">Responses</Typography></MenuItem>
          </Menu>
          <br/>          
          <DonutChart
            labels={["Mailed", "Holdouts"]}            
            data={getDonutSeries()}
            colors={["#ad64de", "#ffa53d"]}
            radius={'70%'}
            labelShow={true}
            legend={true}
            position={'top'}
            height={250}
            darkMode={darkMode}
          />
        </div>
      </div>
    </div>
  )
}

export default EventMarketing
